import axios from "axios";
import { API_URL } from "../../const";

//***************TCN REPONSE GET DETAILS START****************/
export const tcnResponseGetAPI = (Data: any) => {
  const data = {
    TCNResponseToken: Data,
  };
  const url = `${API_URL}getTCNResponse`;
  return axios.post(url, data, {
    headers: { "Content-Type": "application/json" },
  });
};
//***************TCN REPONSE GET DETAILS END****************/

export const getTCNDispositionGroupAPI = (data: any) => {
  const payload = {
    GetAllGroupDispositionDetailsToken: data,
  };
  const url = `${API_URL}getTCNGroupDisposition`;
  return axios.post(url, payload, {
    headers: { "Content-Type": "application/json" },
  });
};

//***************COMMON EXPORT  DETAILS START****************/

export const ComonExportPage = (fetchData: JSON) => {
  const data = {
    CreateRequestReportToken: fetchData,
  };

  const url = `${API_URL}CreateRequestReport`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
//***************COMMON EXPORT  DETAILS END****************/
